import { createAction, props } from '@ngrx/store'
import { IUser } from '../../user'

export const user_loaded = createAction('[Auth] User Loaded', props<{ user: IUser }>())

export const user_unloaded = createAction('[Auth] User Unloaded')

export const user_signed_out = createAction('[Auth] User Signed Out')

export const session_timer_reset = createAction('[Auth] Session Timer Reset')

export const session_timer_warning = createAction('[Auth] Session Timer Warning')

export const cancel_session_timer = createAction('[Auth] Cancel Session Timer')

export const logout_user = createAction('[Auth] Logout User')

export const initiate_login = createAction('[Auth] Initiate Login', props<{ url: string }>())

export const login_failed = createAction('[Auth] Login Failed')

export const login_succeeded = createAction('[Auth] Login Succeeded')

export const initiate_logout = createAction(
  '[Auth] Initiate Logout',
  props<{ destination?: string; confirm?: boolean }>()
)

export const logout_failed = createAction('[Auth] Logout Failed')

export const logout_succeeded = createAction('[Auth] LogoutSucceeded')

export const logout_aborted = createAction('[Auth] Logout Aborted')
